// useGeoInfo.js
import { useEffect, useState } from 'react';
import axios from 'axios';

const useGeoInfo = () => {
  const [geoInfo, setGeoInfo] = useState({
    ip: '',
    lat: '',
    lng: '',
    country: '',
    city: '',
    region: '',
  });

  useEffect(() => {
    const fetchIPInfo = async () => {
      try {
        // أولًا: نجيب الـ IP
        const ipRes = await axios.get('https://api.ipify.org?format=json');
        const ip = ipRes.data.ip;

        // ثانيًا: نجيب الموقع الجغرافي باستخدام الـ IP
        const geoRes = await axios.get(`https://freeipapi.com/api/json/${ip}`);

        setGeoInfo({
          ip,
          lat: geoRes.data.latitude,
          lng: geoRes.data.longitude,
          country: geoRes.data.countryName,
          city: geoRes.data.cityName,
          region: geoRes.data.regionName,
        });
      } catch (err) {
        console.error('Error fetching geo info:', err);
      }
    };

    fetchIPInfo();
  }, []);

  return geoInfo;
};

export default useGeoInfo;
